/**
 * Error Boundary Component
 */

import React from 'react';
import '@components/common/ErrorBoundary.css';

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Error Boundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary">
          <div className="error-boundary__content">
      <h2 className="error-boundary__title">Something went wrong</h2>
            <p className="error-boundary__message">{this.state.error?.message}</p>
      <button
   className="error-boundary__button"
              onClick={() => this.setState({ hasError: false, error: null })}
            >
       Try again
 </button>
          </div>
      </div>
      );
}

    return this.props.children;
  }
}

export default ErrorBoundary;
